import { useEffect, useRef } from "react";
import { Eraser } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SignaturePad = ({ onChange, testId = "signature-pad" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  const setup = () => {
    const c = ref.current;
    const w = c.offsetWidth * 2, h = c.offsetHeight * 2;
    if (c.width === w && c.height === h) return;
    c.width = w;
    c.height = h;
    const ctx = c.getContext("2d");
    ctx.scale(2, 2);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0F172A";
  };
  useEffect(() => { setup(); }, []);

  const pos = (e) => { const c = ref.current, r = c.getBoundingClientRect(); return [(e.clientX - r.left) * (c.offsetWidth / r.width), (e.clientY - r.top) * (c.offsetHeight / r.height)]; };
  const down = (e) => { e.preventDefault(); if (!dirty.current) setup(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); ctx.lineTo(...pos(e)); ctx.stroke(); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); dirty.current = true; };
  const up = () => { if (!drawing.current) return; drawing.current = false; if (dirty.current) onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(null); };

  return (
    <div className="space-y-1.5">
      <div className="relative rounded-lg border-2 border-dashed border-slate-300 bg-white">
        <canvas ref={ref} className="h-40 w-full touch-none cursor-crosshair" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid={testId} />
        <span className="pointer-events-none absolute bottom-2 left-3 right-3 border-t border-slate-200 pt-1 text-[10px] uppercase tracking-wider text-slate-400">Firma qui</span>
      </div>
      <Button type="button" size="sm" variant="ghost" onClick={clear} data-testid={`${testId}-clear`}><Eraser className="mr-1 h-3.5 w-3.5" /> Cancella firma</Button>
    </div>
  );
};
